export const seoData = {
  home: {
    title: "CYGA EVENEMENT - Spectacles Pyrotechniques en France | Créateur de Frissons",
    description: "CYGA EVENEMENT, créateur de frissons. Spectacles pyrotechniques pour mariages, communes, événements et spectacles transportables partout en France. Plus de 15 ans d'expertise.",
    keywords: "spectacle pyrotechnique, feux d'artifice, mariage, événement, commune, spectacle transportable, pyrotechnie, France, CYGA, créateur de frissons",
    url: "https://www.cyga-evenement.fr",
    image: "https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/iagmxpji_Cyga%20events%20Visuel%20Site-02.png"
  },
  mariages: {
    title: "Spectacles Pyrotechniques pour Mariages | CYGA EVENEMENT",
    description: "Créez des souvenirs inoubliables pour votre mariage avec un spectacle pyrotechnique sur mesure par CYGA EVENEMENT. Émerveillez vos invités avec un feu d'artifice magique.",
    keywords: "feux d'artifice mariage, spectacle pyrotechnique mariage, pyrotechnie mariage, animation mariage, feu d'artifice nuptial, France",
    url: "https://www.cyga-evenement.fr/mariages",
    image: "https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/ilg8oney_0532_IMGP9943-Edit.jpg"
  },
  communes: {
    title: "Spectacles Pyrotechniques pour Communes | CYGA EVENEMENT",
    description: "Illuminez vos festivités communales avec des spectacles pyrotechniques professionnels. CYGA EVENEMENT accompagne les mairies pour des événements mémorables.",
    keywords: "feux d'artifice commune, spectacle pyrotechnique mairie, pyrotechnie festivités communales, 14 juillet, fête nationale, événement municipal",
    url: "https://www.cyga-evenement.fr/communes",
    image: "https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/iagmxpji_Cyga%20events%20Visuel%20Site-02.png"
  },
  evenementiel: {
    title: "Spectacles Pyrotechniques pour Événements | CYGA EVENEMENT",
    description: "Donnez une dimension spectaculaire à vos événements professionnels et privés avec CYGA EVENEMENT. Spectacles pyrotechniques sur mesure qui marquent les esprits.",
    keywords: "feux d'artifice événement, spectacle pyrotechnique entreprise, pyrotechnie événementiel, animation événement, inauguration, soirée entreprise",
    url: "https://www.cyga-evenement.fr/evenementiel",
    image: "https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/iagmxpji_Cyga%20events%20Visuel%20Site-02.png"
  },
  spectacles: {
    title: "Spectacles Transportables | CYGA EVENEMENT",
    description: "Des spectacles pyrotechniques transportables pour sublimer vos événements partout en France. Matériel professionnel et expertise garantie par CYGA EVENEMENT.",
    keywords: "spectacle pyrotechnique transportable, feux d'artifice mobile, pyrotechnie itinérante, spectacle déplaçable, France",
    url: "https://www.cyga-evenement.fr/spectacles-transportables",
    image: "https://customer-assets.emergentagent.com/job_ce7badca-1eed-4434-a9d2-436f81188f7a/artifacts/ou6tngwe_IMG_0286.jpeg"
  },
  laisserAvis: {
    title: "Laissez Votre Avis | CYGA EVENEMENT",
    description: "Partagez votre expérience avec CYGA EVENEMENT. Votre avis compte et nous aide à améliorer nos spectacles pyrotechniques.",
    keywords: "avis CYGA, témoignage spectacle pyrotechnique, retour d'expérience, satisfaction client",
    url: "https://www.cyga-evenement.fr/laisser-avis",
    image: "https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/iagmxpji_Cyga%20events%20Visuel%20Site-02.png"
  }
};
